import React from "react";
import PropTypes from "prop-types";
import RescheduleChatBtn from "./reschedule-chat-btn";
import JoinChatBtn from "./join-chat-btn";
import moment from "moment";
import UnconfirmedAppointmentActions from "./unconfirmed-appointment-actions";
import ConfirmationModal from "./confirmation-modal";
import { fromTo } from "utils/misc";
import { TableCell, TableRow, Tooltip } from "@mui/material";
import { getCancelAriaLabelledBy } from "./appointment-utils";
import { useAppointmentLogic } from "./use-appointment-logic";
import useTranslate from "hooks/use-translate-language";
import ClockIcon from "assets/images/clock_gray.png";

const UpcomingChat = ({ chats, master_chat_type }) => {
  const translate = useTranslate();
  const {
    displaySpinner,
    speaksSpanish,
    browserTimezone,
    chat_details,
    topic_details,
    is_confirmed,
    is_cancelled,
    getStatusColor,
    remainingTime,
    onCancelAppointment,
    startTimeFromCSTToBrowser,
    endTimeFromCSTToBrowser,
    timeUntilAppointment
  } = useAppointmentLogic(chats, master_chat_type);
  return (
    <TableRow>
      <TableCell aria-labelledby="date-header">
        <div className="upcoming-chat-date-container">
          <img src={ClockIcon} alt="" aria-hidden="true" />
          <div>
            <div style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
              {`${moment(chat_details.date_time).format("MMM")} ${moment(
                chat_details.date_time
              ).format("DD")} ${moment(chat_details.date_time).format("yyyy")}`}
            </div>
            <div className="chat-time">
              {`${fromTo(
                startTimeFromCSTToBrowser,
                endTimeFromCSTToBrowser,
                translate("to")
              )} (${moment.tz(browserTimezone).format("z")})`}
            </div>
          </div>
        </div>
      </TableCell>

      <TableCell aria-labelledby="topic-header">
        {`${
          !speaksSpanish
            ? topic_details[0]?.topic_name
            : topic_details[0]?.spanish_topic_name ??
              topic_details[0]?.topic_name
        } | `}
        <span style={{ whiteSpace: "nowrap" }}>
          {translate(master_chat_type)}
        </span>
      </TableCell>
      <TableCell aria-labelledby="with-header">
        {chat_details.dme_details?.name}
      </TableCell>
      <TableCell
        style={{ paddingLeft: "0", paddingRight: "0" }}
        aria-labelledby="status-header"
      >
        <span
          className="status-info"
          style={getStatusColor(chat_details.meeting_status)}
        >
          {chat_details.meeting_status === "Un-confirmed"
            ? translate("confirmationPending")
            : translate(chat_details.meeting_status.toLowerCase())}
        </span>
      </TableCell>
      <TableCell aria-labelledby="starts-in-header">
        {!is_cancelled &&
          (timeUntilAppointment > 0 ? (
            <div>
              <div>{`${remainingTime.days} ${translate("days")} `}</div>
              <div>
                {`${remainingTime.hours} ${translate("hours")} : ${
                  remainingTime.minutes
                } ${translate("minutes")}`}
              </div>
            </div>
          ) : (
            <div>{translate("startsNow")}</div>
          ))}
      </TableCell>
      <TableCell aria-labelledby="description-header">
        {chat_details.description && (
          <Tooltip
            title={chat_details.description}
            arrow
            disableHoverListener={chat_details.description.length <= 100}
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: "14px",
                  maxWidth: "300px"
                }
              }
            }}
          >
            <div
              style={{
                maxWidth: "200px",
                maxHeight: "80px",
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: 4,
                WebkitBoxOrient: "vertical",
                lineHeight: "20px"
              }}
            >
              {chat_details.description}
            </div>
          </Tooltip>
        )}
      </TableCell>
      <TableCell className="upcoming-chat-actions" aria-labelledby="actions-header">
        {!is_cancelled &&
          ((remainingTime.days == 0 &&
            remainingTime.hours == 0 &&
            remainingTime.minutes <= 5) ||
            timeUntilAppointment <= 0) && (
            <JoinChatBtn
              {...chat_details}
              master_chat_type={master_chat_type}
            />
          )}
        {!is_cancelled &&
          !chat_details.is_product_demo &&
          chat_details.created_by_patient && (
            <RescheduleChatBtn
              {...chat_details}
              is_confirmed={is_confirmed}
              master_chat_type={master_chat_type}
            />
          )}
        {!is_cancelled && !chat_details.created_by_patient && (
          <UnconfirmedAppointmentActions
            chat_id={chat_details.chat_id}
            accepted={!is_confirmed ? null : is_confirmed}
          />
        )}
        {chat_details.can_be_cancelled && (
          <ConfirmationModal
            buttonText="cancel"
            title="cancelAppointment"
            message="cancelAppointmentConfirmationMessage"
            onYes={closeModal =>
              onCancelAppointment(chat_details.slot_id, closeModal)
            }
            spinner={displaySpinner}
            ariaLabelledBy={getCancelAriaLabelledBy(chat_details)}
          />
        )}
      </TableCell>
    </TableRow>
  );
};

UpcomingChat.propTypes = {
  chats: PropTypes.arrayOf(PropTypes.object),
  master_chat_type: PropTypes.string
};

export default UpcomingChat;
